import React from "react";
import { Box } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, } from "recharts";
const colors = [
    "#007FFF",
    "#FE0089",
    "#B20060",
    "#184B44",
    "#FFD700",
    "#FF9F40",
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#4BC0C0",
    "#2D1E4C",
    "#FF9F40",
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
];
const ResultGraphStacked = ({ data, datasetLabels, labelOverride, }) => {
    // get VarietyName and the data for each variety.
    // The RowIndex is what maps the data to the correct variety.
    const filteredData = data
        .filter((cell) => cell.columnIndex === 0)
        .map((cell) => {
        return {
            name: cell.cellValue,
            rowIndex: cell.rowIndex,
        };
    });
    // add each extra column to the data for each variety. e.g. Summer, Winter, etc.
    const otherColumns = data.filter((cell) => cell.columnIndex !== 0);
    otherColumns.forEach((cell) => {
        const cellIndex = cell.columnIndex;
        const rowIndex = cell.rowIndex;
        const addToFilteredDataFromData = data.find((dataCell) => dataCell.columnIndex === cellIndex && dataCell.rowIndex === rowIndex);
        if (addToFilteredDataFromData) {
            filteredData.forEach((filteredCell) => {
                if (filteredCell.rowIndex === rowIndex) {
                    const columnName = addToFilteredDataFromData.columnName;
                    filteredCell[columnName] = addToFilteredDataFromData.cellNumericValue;
                }
            });
        }
    });
    // Calculate the total yield for each variety and add it to the filteredData
    const finalData = filteredData
        .map((item) => {
        return Object.assign(Object.assign({}, item), { totalYield: Object.keys(item)
                .filter((key) => key !== "name" && key !== "rowIndex")
                .reduce((sum, key) => sum + item[key], 0) });
    })
        .sort((a, b) => b.totalYield - a.totalYield);
    // Sort the filteredData array based on the total yield in descending order
    finalData.sort((a, b) => b.totalYield - a.totalYield);
    // Transform the camel case keys to pascal case and split the words
    const transformCamelToPascalAndSplit = (str) => {
        const pascalCase = str.charAt(0).toUpperCase() + str.slice(1);
        return pascalCase.replace(/([a-z])([A-Z])/g, "$1 $2");
    };
    // Get the keys of the first data item to dynamically create bars
    const keys = finalData.length > 0
        ? Object.keys(finalData[0]).filter((key) => key !== "name" && key !== "rowIndex" && key !== "totalYield")
        : [];
    const chartWidth = Math.max(800, finalData.length * 35); // Minimum 800px, then 35px per data point
    const shouldScroll = chartWidth > 1200; // Add horizontal scroll if chart is too wide
    return (React.createElement(Box, { sx: {
            width: "100%",
            height: "600px",
            overflow: shouldScroll ? "auto" : "hidden",
            border: "1px solid #e0e0e0",
            borderRadius: 1
        } },
        React.createElement(BarChart, { width: chartWidth, height: 600, data: finalData, margin: {
                top: 20,
                right: 30,
                left: 20,
                bottom: 80, // Increased bottom margin for angled labels
            }, barCategoryGap: "5%" // Reduced gap between bar categories for thinner appearance
         },
            React.createElement(CartesianGrid, { strokeDasharray: "3 3" }),
            React.createElement(XAxis, { dataKey: "name", tick: { fontSize: 11 }, height: 80, interval: 0, angle: -45, textAnchor: "end" // Align text to end for better readability
             }),
            React.createElement(YAxis, null),
            React.createElement(Tooltip, null),
            React.createElement(Legend, null),
            keys.map((key, index) => (React.createElement(Bar, { dataKey: key, key: `bar-${key}`, stackId: "a", fill: colors[index % colors.length], name: transformCamelToPascalAndSplit(key), maxBarSize: 30 }))))));
};
export default ResultGraphStacked;
